(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function getEcommerceURL(ecommerceBaseURL, language, segment, productId) {
		var eCommerceURL = ecommerceBaseURL;
		eCommerceURL = eCommerceURL.replace('%LANG%', language);
		eCommerceURL = eCommerceURL.replace('%SEGMENT%', segment);
		eCommerceURL = eCommerceURL + productId;
		return eCommerceURL;
	}
	var DATA_EXTRACTORS = {
		ecommerceproduct: function(keymatch, data, ecommerceBaseURL) {
			keymatch.segment = data[2];
			keymatch.language = data[3];
			keymatch.productId = data[4];
			keymatch.eCommerceURL = getEcommerceURL(ecommerceBaseURL, keymatch.language, keymatch.segment, keymatch.productId);
			keymatch.display = 'product';
			// Fill in title and subtitle generically
			this.generic(keymatch, data);
		},
		product: function(keymatch, data) {
			keymatch.brand = data[0];
			keymatch.product = data[1];
			keymatch.image = data[2];
			keymatch.rating = data[3];
			keymatch.ratingCount = data[4];
			// Fill in title and subtitle generically
			this.generic(keymatch, data);
		},
		webcode: function(keymatch) {
			keymatch.redirectTo = keymatch.url;
		},
		generic: function(keymatch, data) {
			keymatch.title = data[0];
			keymatch.subtitle = data[1];
		},
		selfcare: function(keymatch, data) {
			keymatch.isSelfcare = true;
			this.generic(keymatch, data);
		}
	};
	function splitKeymatchData(dataExtractors, ecommerceBaseURL) {
		ecommerceBaseURL = ecommerceBaseURL || '/portalshop-api/%LANG%/%SEGMENT%/Product/GetFamilyData/';
		dataExtractors = dataExtractors || DATA_EXTRACTORS;

		return function keymatchDataSplitter(data, config, callback) {
			var keymatches = data.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}
			config.keymatches = [];
			for(var i=0;i<keymatches.length;i+=1) {
				var keymatch = search.util.extend({}, keymatches[i]);
				keymatch.data = keymatch.data.split(/\|/);
				keymatch.type = keymatch.data.pop().toLowerCase();
				keymatch.display = keymatch.type;
				if(keymatch.type in dataExtractors) {
					dataExtractors[keymatch.type](keymatch, keymatch.data, ecommerceBaseURL);
				}
				config.keymatches.push(keymatch);
			}
			callback();
		};
	}

	function redirectToKeymatch(redirector) {
		redirector = redirector || function(url) {
			window.location = url;
		};

		return function keymatchRedirector(data, config, callback) {
			var keymatches = config.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}

			for(var i=0;i<keymatches.length;i+=1) {
				var keymatch = keymatches[i];
				if(keymatch.redirectTo) {
					redirector(keymatch.redirectTo);
					this.abort();
					return callback();
				}
			}
			callback();
		};
	}

	var DATA_AGGREGATORS = {
		ecommerceproduct: function(keymatch, backend, callback) {
			return backend(keymatch.eCommerceURL, function(response) {
				keymatch.error = response instanceof Error ? response : null;
				if (!response || !response.ProductDataFamily || response instanceof Error) {
					return callback();
				}

				var family = response.ProductDataFamily;
				keymatch.brand = family.ProductBrand;
				keymatch.product = family.ProductName;
				keymatch.tagline = family.ProductSlogan;

				keymatch.title = (keymatch.brand || keymatch.title) + ' ' + (keymatch.product || keymatch.subtitle);
				keymatch.subtitle = keymatch.tagline || '';

				var familyRating = family.AggregatedFamilyRatingSummary;
				if(familyRating) {
					keymatch.ratingCount = familyRating.NumberOfRatings;
					keymatch.rating = familyRating.Rating;
				}

				var familyProductData = family.FamilyProductData;
				if (familyProductData && familyProductData.length > 0) {
					keymatch.image = familyProductData[0].ProductImageSmall;
				}

				callback();
			});
		}
	};
	var DEFAULT_AGGREGATOR = function(keymatch, backend, callback) {
		callback({});
	};
	function aggregateKeymatchContents(backend, dataAggregators) {
		dataAggregators = dataAggregators || DATA_AGGREGATORS;

		return function keymatchContentsAggregator(data, config, callback) {
			var keymatches = config.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}
			// Use the current backend to request data from ecommerce
			var aggregateBackend = backend || this.processor.backend;
			var aggregators = [];
			function aggregator(keymatch) {
				return function(callback) {
					var aggregator = keymatch.type in dataAggregators ? dataAggregators[keymatch.type] : DEFAULT_AGGREGATOR;
					aggregator(keymatch, aggregateBackend, callback);
				};
			}
			for(var i=0;i<keymatches.length;i+=1) {
				aggregators.push(aggregator(keymatches[i]));
			}
			// Delay results until keymatches are loaded from ecommerce.
			// FIXME: Is this a good idea?
			return search.util.parallel(aggregators, callback);
		};
	}

	function setUp(processor, keymatchDataSplitter, keymatchContentsAggregator, keymatchRedirector, weight) {
		weight = weight || 300;
		processor.usePost(keymatchDataSplitter||splitKeymatchData(), weight);
		processor.usePost(keymatchContentsAggregator||aggregateKeymatchContents(), weight+20);
		if(keymatchRedirector) {
			// Only use if explicitly passed
			processor.usePost(keymatchRedirector, weight+10);
		}
	}

	var plugins = search.plugins = search.plugins || {};
	var keymatch = plugins.keymatch = plugins.keymatch || {};

	keymatch.splitKeymatchData = splitKeymatchData;
	keymatch.aggregateKeymatchContents = aggregateKeymatchContents;
	keymatch.redirectToKeymatch = redirectToKeymatch;
	keymatch.setUp = setUp;

	if(window.QUnit) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.keymatch = {
			getEcommerceURL: getEcommerceURL
		};
	}

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/keymatch-handling.js
// module id = 56
// module chunks = 0